__webpack_require__.p = "/wb/wobo-frontend/dist/";